import { render, staticRenderFns } from "./address.vue?vue&type=template&id=14affca0&scoped=true&"
import script from "./address.vue?vue&type=script&lang=js&"
export * from "./address.vue?vue&type=script&lang=js&"
import style0 from "./address.vue?vue&type=style&index=0&id=14affca0&prod&lang=less&"
import style1 from "./address.vue?vue&type=style&index=1&id=14affca0&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14affca0",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SvgIcon: require('/app/components/svgIcon/svgIcon.vue').default,DrawerHeader: require('/app/components/drawer/components/drawerHeader.vue').default})
